export const formConstants = {
  account: [
    {
      label: 'Sender email',
      type: 'email',
      name: 'sender',
      placeholder: 'Sender email',
      required: true
    },
    {
      label: 'Password',
      type: 'password',
      name: 'password',
      placeholder: 'Password',
      required: true,
      ignoreOnEdit: true
    },
    {
      label: 'Host',
      type: 'text',
      name: 'host',
      placeholder: 'Host',
      required: true
    },
    {
      label: 'Port',
      type: 'number',
      name: 'port',
      placeholder: 'Port',
      required: true
    }
  ],
  audience: [
    {
      label: 'Name',
      type: 'text',
      name: 'name',
      placeholder: 'Name',
      required: true
    }
  ],
  campaign: [
    {
      label: 'Name',
      type: 'text',
      name: 'name',
      placeholder: 'Name',
      required: true
    },
    {
      label: 'Subject',
      type: 'text',
      name: 'subject',
      placeholder: 'Subject',
      validate: (value, getValues) => {
        return !(getValues.ready && value === '')
      }
    },
    {
      label: 'Max attempts',
      type: 'number',
      name: 'maxAttempts',
      placeholder: 'Max attempts',
      defaultValue: 3,
      validate: (value, getValues) => {
        return !(getValues.ready && value === '' && value < 1)
      }
    },
    {
      label: 'Delay between attempts',
      type: 'select',
      name: 'delayBetweenAttempts',
      placeholder: 'Delay between attempts',
      required: true,
      defaultValue: 3600,
      options: [
        { value: 60, label: '1 minute' },
        { value: 300, label: '5 minutes' },
        { value: 600, label: '10 minutes' },
        { value: 1800, label: '30 minutes' },
        { value: 3600, label: '1 hour' },
        { value: 7200, label: '2 hours' },
        { value: 14400, label: '4 hours' },
        { value: 28800, label: '8 hours' },
        { value: 43200, label: '12 hours' },
        { value: 86400, label: '1 day' },
        { value: 172800, label: '2 days' },
        { value: 259200, label: '3 days' }
      ]
    },
    {
      label: 'Account',
      type: 'account',
      name: 'account',
      placeholder: 'Account',
      validate: (value, getValues) => {
        return !(getValues.ready && value === '')
      }
    },
    {
      label: 'Audience',
      type: 'audience',
      name: 'audience',
      placeholder: 'Audience',
      validate: (value, getValues) => {
        return !(getValues.ready && value === '')
      }
    },
    {
      label: 'Recipient field',
      type: 'recipient',
      name: 'recipient',
      placeholder: 'Recipient',
      validate: (value, getValues) => {
        return !(getValues.ready && value === '')
      }
    },
    {
      label: 'Template',
      type: 'template',
      name: 'template',
      placeholder: 'Template',
      validate: (value, getValues) => {
        return !(getValues.ready && value === '')
      }
    },
    {
      label: 'Campaign is ready to send',
      type: 'checkbox',
      name: 'ready',
      placeholder:
        'By selecting this option, emails will be created and the campaign will be ready to go. Note: when select this option, all fields will be required.',
      required: false
    }
  ],
  organization: [
    {
      label: 'Name',
      description: 'Only lowercase letters and numbers',
      type: 'text',
      name: 'name',
      placeholder: 'Name',
      required: true,
      validate: (e) => /^[a-z0-9]+$/.test(e)
    },
    {
      label: 'Password',
      description: 'Min 6 characters',
      type: 'password',
      name: 'password',
      placeholder: 'Password',
      required: true,
      ignoreOnEdit: true,
      validate: (e) => (e === '' ? true : e.length > 5)
    }
  ],
  joinOrganization: [
    {
      label: 'Organization name',
      type: 'text',
      name: 'name',
      placeholder: 'Organization name',
      required: true
    },
    {
      label: 'Password',
      type: 'password',
      name: 'password',
      placeholder: 'Password',
      required: true,
      validate: (e) => e.length > 5
    }
  ],
  template: [
    {
      label: 'Name',
      description: 'Only lowercase letters and numbers',
      type: 'text',
      name: 'name',
      placeholder: 'Name',
      required: true
    }
  ]
}
